import React, { useState, useEffect, useRef } from "react";
import { Table } from "antd";

const transformTableData = (data = []) => {
  const cols = data?.[0]?.attributes?.map((at) => {
    return {
      title: at.name,
      dataIndex: at.name,
      key: at.name,
    };
  });
  const otherCols = cols.filter((item) => item.dataIndex !== "Selling Price");
  const sellPriceCol =
    cols.length === otherCols.length
      ? []
      : [
          {
            title: "Price",
            dataIndex: "Selling Price",
            key: "Selling Price",
          },
        ];
  const rows = data.map((r) => {
    const attrs = r?.attributes?.reduce((previousAttr, currentAttr, index) => {
    
      const name = currentAttr.name.toLowerCase()
      const price=  name.includes('price');

      return {
        ...previousAttr,
        [currentAttr.name]: price ?  currentAttr?.value && currentAttr?.value.split(' ').slice(0,2).join(' ') : currentAttr.value,
      };
    }, {});
console.log("attrs",attrs)
    return {
      "Variant Id": r.variant_id,
      ...attrs,
    };
  });

  return {
    rows,
    cols: [
      {
        title: "Variant ID",
        dataIndex: "Variant Id",
        key: "Variant Id",
      },
      ...otherCols,
      ...sellPriceCol,
    ],
  };
};

const VariantsTable = ({ data }) => {
  const [{ rows, cols }, setTableData] = useState({});

  useEffect(() => {
    const { rows, cols } = transformTableData(data);
    setTableData({ rows, cols });
  }, [data]);

  return (
    <div>
      <Table
        bordered
        columns={cols}
        size="small"
        scroll={{ x: "max-content" }}
        dataSource={rows}
        pagination={false}
      />
    </div>
  );
};

export default VariantsTable;
